// Ponte tra l'interceptor axios e la modale di re-login: su 401 si apre la
// modale invece di un redirect che farebbe perdere il lavoro non salvato.
// I 401 concorrenti condividono la stessa modale e la stessa promise.

// Ritorna il nuovo token dopo il re-login, oppure null se l'utente annulla.
type ReloginHandler = () => Promise<string | null>;

let handler: ReloginHandler | null = null;
let inFlight: Promise<string | null> | null = null;

/** Registrato dalla ReloginModal al mount (null allo unmount). */
export function registerReloginHandler(fn: ReloginHandler | null): void {
    handler = fn;
}

/** Chiamata dall'interceptor. Coalizza i 401 concorrenti su una singola modale. */
export function requestRelogin(): Promise<string | null> {
    if (!handler) return Promise.resolve(null);
    if (!inFlight) {
        inFlight = handler().finally(() => { inFlight = null; });
    }
    return inFlight;
}
